import { Input } from 'antd';
import { Trash } from '@styled-icons/boxicons-regular';
import { ItemsText, StyledDeleteDrawer } from './DeleteDrawer.styled';
import ActionsFooter from '@/shared/StepActionsFooter/StepActionsFooter';
import { Paragraph, Text, Title } from '@/shared/Typography';
import Colors from '@/constants/Colors';

export default function DeleteClasses({
  resource,
  state,
  items = [],
  renderItemName,
  actions,
  confirm = true,
  children,
  ...props
}) {
  return (
    <StyledDeleteDrawer
      title={
        <Text type="secondary" strong>
          Delete {resource}
        </Text>
      }
      onClose={actions.onActionCancelled}
      footer={
        <ActionsFooter
          cancel="Cancel"
          cancelAction={actions.onActionCancelled}
          finish="Delete"
          finishAction={actions.delete}
          danger={true}
          disabled={state.confirmDisabled}
          processing={state.deleting}
        />
      }
      {...props}
    >
      <Title level={1} color={Colors.error}>
        Are you sure?
      </Title>

      <Paragraph strong>
        You are going to delete the following {resource}:
      </Paragraph>

      {items.map((item) => {
        return (
          <ItemsText type="secondary" key={item.id}>
            <Trash width={15} height={15} />
            {renderItemName(item)}
          </ItemsText>
        );
      })}

      {confirm ? (
        <>
          <Paragraph>
            To ensure you are not doing this by accident, write the word
            "DELETE" bellow and then press the{' '}
            <Text strong type="secondary">
              Confirm Deletion
            </Text>{' '}
            button.
          </Paragraph>
          <Input
            placeholder="Type DELETE here"
            maxLength={6}
            onChange={(e) => {
              actions.activateConfirmButton(e.target?.value);
            }}
          />
        </>
      ) : null}

      {children}
    </StyledDeleteDrawer>
  );
}
